
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BookOpen } from "lucide-react";

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  actionHref?: string;
  icon?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  actionHref,
  icon = <BookOpen className="h-16 w-16 text-gray-600 mb-4" />
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 bg-[#1A2233] border border-[#222A35] rounded-lg text-center">
      {icon}
      <h2 className="text-xl font-semibold text-white mb-2">{title}</h2>
      <p className="text-gray-400 mb-6 max-w-md">{description}</p>
      
      {actionLabel && actionHref && (
        <Link to={actionHref}>
          <Button className="bg-[#00B6F0] hover:bg-[#0095c7] text-black font-medium">
            {actionLabel}
          </Button>
        </Link>
      )}
    </div>
  );
};
